import React, { useState } from 'react';
import { MdOutlineLocationOn, MdOutlineContentCopy, MdOutlineCheck } from 'react-icons/md';
import { Chip, FactGrid, Note } from './ui';
import { fmtCoords, titleCase, displayAddress, safeArray } from '../format';

export default function LocationSummary({ location }) {
  const [copied, setCopied] = useState(false);
  if (!location) return null;
  const canonical = location.canonical_address || {};
  const coords = location.coordinates || {};
  const geo = location.geographies || {};
  const resolution = location.resolution || {};
  const warnings = safeArray(resolution.warnings);
  const coordText = fmtCoords(coords.latitude, coords.longitude);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(coordText);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) { /* clipboard unavailable */ }
  };

  return (
    <div className="le-location">
      <div className="le-location-head">
        <MdOutlineLocationOn size={18} />
        <div className="le-location-address">{displayAddress(canonical.formatted) || location.requested?.address || coordText}</div>
      </div>
      <div className="le-chip-row">
        {canonical.county_name ? <Chip>{canonical.county_name}</Chip> : null}
        {canonical.postal_code ? <Chip>ZIP {canonical.postal_code}</Chip> : null}
        {geo.county_fips ? <Chip mono title="County FIPS">FIPS {geo.county_fips}</Chip> : null}
        {geo.census_tract_id ? <Chip mono title="Census tract">Tract {geo.census_tract_id}</Chip> : null}
      </div>
      <FactGrid
        columns={1}
        items={[
          {
            label: 'Coordinates',
            value: (
              <span className="le-coords">
                <span className="mono">{coordText}</span>
                <button type="button" className="le-icon-btn" onClick={copy} title="Copy coordinates" aria-label="Copy coordinates">
                  {copied ? <MdOutlineCheck size={14} /> : <MdOutlineContentCopy size={14} />}
                </button>
              </span>
            ),
          },
          { label: 'Resolved by', value: `${titleCase(resolution.method)}${resolution.provider ? ` · ${resolution.provider.replace(/_/g, ' ')}` : ''}${resolution.reverse_geocoded ? ' · reverse geocoded' : ''}` },
          { label: 'Requested as', value: location.requested?.address || (location.requested?.coordinates ? fmtCoords(location.requested.coordinates.latitude, location.requested.coordinates.longitude) : null), muted: true },
        ]}
      />
      {warnings.length ? <Note tone="warning"><ul className="le-warning-list">{warnings.map((w) => <li key={w}>{w}</li>)}</ul></Note> : null}
    </div>
  );
}
